import jwtDecode from 'jwt-decode';
import { unpackRules } from '@casl/ability/extra';
import { AccessTokenDto, UserPermissionRawRule } from '../../types';
import { Action, AppAbility } from '../../AppAbility';

const getAllImpliedActions = (_action: Action | Action[]): Action[] => {
	if (!_action || _action.length !== 1) throw 'Invalid action';
	const action: Action = Array.isArray(_action) ? _action[0] : _action;

	const actions: Action[] = [];
	switch (action) {
		case 'manage':
			actions.push('manage');
		// eslint-disable-next-line no-fallthrough
		case 'edit':
			actions.push('edit');
		// eslint-disable-next-line no-fallthrough
		case 'view':
			actions.push('view');
	}
	return actions;
};

const getAllImpliedSubjects = (_subject: string | string[]): string[] => {
	if (!_subject || _subject.length !== 1) throw 'Invalid subject';
	const subject: string = Array.isArray(_subject) ? _subject[0] : _subject;
	const subjects: string[] = [subject, subject.split('.')[0]];
	return subjects;
};

export const getRulesFromAccessToken = (
	accessToken: string,
): UserPermissionRawRule[] => {
	try {
		const tokenPayload = jwtDecode<AccessTokenDto>(accessToken);
		const payload = tokenPayload.permissions;

		const rulesWithImpliedActionAndSubject = unpackRules<UserPermissionRawRule>(
			payload,
		).map(rule => ({
			...rule,
			subject: getAllImpliedSubjects(rule.subject),
			action: getAllImpliedActions(rule.action),
		}));

		return rulesWithImpliedActionAndSubject;
	} catch (e) {
		console.error('error parsing rules from access token', e);
		return [];
	}
};

export const ability = new AppAbility();
